export const isDev = process.env?.NODE_ENV === 'development'

export const reloadApp = () => {
  window.location.reload()
}
